import { EntityKeyConfig } from '../../../types/entities';

/**
 * Entity Keys for SPECS
 * 
 * Defines the key structure used throughout the application
 * for this entity type.
 */
export const keys: EntityKeyConfig = {
  single: 'spec',
  plural: 'specs',
  state: 'specs'
};
